
// import { Day, Constants, Parse, Schedule, DaySpan, CalendarEvent, Pattern, Patterns, PatternMap, Functions as fn } from 'dayspan';
// import { default as Defaults } from './defaults';
import { default as Colors } from './colors';
// import { default as Icons } from './icons';
// import { default as Locales, defaultLocale } from './locales'
// import { dsMerge, dsMergeLocale } from './functions';
import Vue from 'vue';

const LOCALE_ENTRY = 0;

export default {

  data:
  {
    supports: {
      title:          true,
      description:    true,
      color:          true,
      location:       true,
      calendar:       true,
      busy:           true,
      icon:           true,
      guests:         false
    },
    
    colors: Colors,


  },



  methods:
 {

  setEventDetails(details, data, event, calendarEvent)
  {
    event.data = Vue.util.extend( data, details );
  },
    getDefaultEventColor()
    {
      return this.colors[Math.floor(this.colors.length * Math.random())].value;
    },

  }
};
